import { IntentMessage } from './interface'

const socialPlatform = 'tiktok'

export const normalizedIntentMessage = (intentMessage: IntentMessage) => {
  const { title, url, additionalItems, description, type } = intentMessage
  return {
    url: decodeURIComponent(url) || decodeURIComponent(title) || '',
    additionalItems,
    description,
    type,
  }
}

export const isValidData = (intentMessage: IntentMessage) => {
  const { url = '' } = intentMessage || {}
  return url.includes(socialPlatform)
}

export const isAudio = (path: string) => {
  return /\.(opus|flac|webm|weba|wva|ogg|mp3|oga|mid|amr|aiff|wma|au|aac)/.test(
    path
  )
}
